export default __webpack_public_path__ + "static/media/sounds.7b856b22.wav";